export default __webpack_public_path__ + "f96ddae361d15b182fb07318425fa8f3.png";